import { useSyncExternalStore } from "react";

import {
  getUserPreferences,
  subscribeUserPreferences,
} from "@/lib/stores/user-preference-store";

// Reactive read of the local user-preferences store. `getUserPreferences`
// returns a stable object reference until something actually changes (the store
// only allocates a new object on a real change), which satisfies
// useSyncExternalStore's caching contract. `subscribeUserPreferences` already
// returns an unsubscribe fn and ignores extra listener args, so it slots in
// directly as the subscribe callback.
export function useUserPreferences() {
  return useSyncExternalStore(
    subscribeUserPreferences,
    getUserPreferences,
    getUserPreferences,
  );
}

// Convenience selector for the "hide Sundays" calendar preference.
export function useHideSunday() {
  return useUserPreferences().calendarHideSunday;
}

// Convenience selector for the "merge WhatsApp threads per patient" preference.
export function useMergedWhatsAppView() {
  return useUserPreferences().mergedWhatsAppView;
}

// Convenience selector for the "one row per WhatsApp group" preference, which folds a group's
// per-clinic-gateway copies into a single list row. Distinct from the patient merge above.
export function useMergedWaGroupsView() {
  return useUserPreferences().mergedWaGroupsView;
}

// Convenience selector for the global timezone override ("" = follow the system zone). Reactive:
// components reading this re-render when the override changes, so live time previews update.
export function useAppTimeZoneOverride() {
  return useUserPreferences().appTimeZone;
}
